var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:('width:' + _vm.width + 'rem; height: ' + _vm.height + 'rem; background-image: url('+ _vm.url + '), url(/img/favicon.png); border-radius: ' + _vm.radius + 'px')})}
var staticRenderFns = []

export { render, staticRenderFns }